/**
 * 忘记密码
 * 2017-12-6
 */
"use strict";
angular.module("forgetPasswordModule", [
	"forgetPasswordRouter",//忘记密码路由
	"fauthenticationModule",//身份验证
	"fresetPasswordModule",//重置密码
	"fresetSuccessModule",//重置密码成功
]).controller("forgetPasswordCtrl", ["$scope", "httpService", "$validation", "$element", "$state", '$interval', 'modalDialog', function ($scope, httpService, $validation, $element, $state, $interval, modalDialog) {
	initStatus();
	initData();

	/**
	 * [initStatus description] 初始化参数
	 */
	function initStatus() {
		$scope.status = {
			verificationCode: "/mcnww/web/code/image.do?V=12345678",
			send: false,
			flag: false,
			hasgot: false,
			dialog: false //弹框
		};
		$scope.info = {
			captchaToken: ''
		};
		$scope.data = {
			listData: [],
			alertCode: false,
			same: false, //判断密码是否一致
			captchaToken: false, //验证图形验证码是否错误
			sec: 120
		};
		$scope.zyh = false;
	}

	/**
	 * [initStatus description] 初始化数据
	 */
	function initData() {
	}

	/**
	 * [regularIf description] 判断是否显示正确图标
	 * @return {[type]} [description]
	 */
	$scope.regularIf = function (key, value) {
		switch (key) {
			case 1: //用户名-ok
				$scope.isShowTipsA = false;
				$scope.data.isShowTipsAa = false;
				$scope.data.userAuthentication = false;
				var uesrLength = $element.find('.table>ul>li:first-child>.tips');
				uesrLength.text().length > 8 ? uesrLength.addClass('notPaddintTop') : uesrLength.removeClass('notPaddintTop');
				break;
			case 5: //图形验证码
				$scope.isShowTipsE = false;
				$scope.data.isShowTipsEe = false;
				$scope.data.captchaToken = false;
				break;
		}
		$validation.validate($scope.changePwdForm[value]).success(function () {
			switch (key) {
				case 1:
					$scope.data.isShowTipsAa = true;
					break;
				case 5:
					break;
			}
		});

	};

	/**
	 * [savePwd description]下一步
	 *
	 * @return  {[type]}  [return description]
	 */
	$scope.savePwd = function () {
		if (!$scope.info.userName || $scope.info.userName == '') {
			$scope.isShowTipsA = false;
			$scope.data.isShowTipsAa = false;
			return
		}
		if (!$scope.info.phoneYzm || $scope.info.phoneYzm.trim().length != 6) {
			$scope.isShowTipsE = false;
			$scope.data.isShowTipsEe = false;
			return
		}
		httpService.http('/mcnww/web/code/valid.do', {
			name: 'smsToken',
			param: $scope.info.phoneYzm
		}, 'get').then(function (data) {
			if (data.status == 'y') {
				var params = angular.copy($scope.info);
				$state.go('forgetpassword.resetpassword', {userName: params.userName});
				// $validation.validate($scope.changePwdForm).success(function () {
				//
				// }).error(function () {
				// 	angular.invalidPosition($scope.changePwdForm, $element);
				// });
			} else {
				$scope.reGetYzm=true;
				$scope.data.errInfo=data.info;
				$scope.data.captchaToken = true;
				$scope.data.isShowTipsEe = false;
			}
		});


	};

	/**
	 * [updateImg description] 更新图片验证码
	 * @return {[type]} [description]
	 */
	$scope.updateImg = function () {
		var imgArray = $scope.status.verificationCode.split("=");
		imgArray[1] = Math.random();
		$scope.status.verificationCode = imgArray.join("=");
	};

	/**
	 * [getYzm description] 获取手机验证码
	 * @return {[type]} [description]
	 */
	$scope.getYzm = function () {
		if (!$scope.data.isShowTipsA && $scope.data.isShowTipsAa == false) {
			return;
		} else {
			$scope.status.dialog = true;
			$scope.reGetYzm=false;
			$scope.updateImg();
			$scope.info.captchaToken = '';
		}
	};

	/**
	 * [reduceSec description] 倒计时
	 * @return {[type]} [description]
	 */
	function reduceSec() {
		httpService.http('/mcnww/web/code/sms.do', {
			mobile: $scope.info.userName
		}, 'post').then(function (data) {
		});

		let timer = null;
		$interval.cancel(timer);
		timer = $interval(function () {
			if ($scope.data.sec > 1) {
				$scope.data.sec--;
			} else {
				$scope.status.hasgot = false;
				$scope.data.sec = 120;
				$interval.cancel(timer);
			}
		}, 1000);
	}

	/**
	 * [confimDialog description] 确认弹框
	 * @return {[type]} [description]
	 */
	$scope.confimDialog = function () {
		if (!$scope.info.captchaToken || $scope.info.captchaToken == '' || $scope.info.captchaToken.trim().length != 4) {
			$scope.isShowTipsF=false;
			$scope.data.isShowTipsFf=false;
			return
		}
		httpService.http('/mcnww/web/code/valid.do', {
			name: 'captchaToken',
			param: $scope.info.captchaToken
		}, 'get').then(function (data) {
			if (data.status == 'n') { //失败
				$scope.data.captchaToken = true;
				$scope.isShowTipsF = false;
				$scope.updateImg();
			} else { // 成功
				$scope.status.dialog = false;
				$scope.isShowTipsF=true;
				yzPhone()
			}
		});
	}

	/**
	 * [closeDialog description] 关闭弹框
	 * @return {[type]} [description]
	 */
	$scope.closeDialog = function () {
		$scope.status.dialog = false;
		$scope.isShowTipsF=true
	}

	/**
	 * [yzPhone description] 验证手机号是否存在
	 * @return {[type]} [description]
	 */
	function yzPhone() {
		$scope.zyh = false;
		httpService.http('/mcnww/web/user/existsValid.do', {
			name: 'mobile',
			param: $scope.info.userName
		}, 'post').then(function (data) {
			if (data.status == 'n') { //成功
				$scope.data.isShowTipsAa = true;
				$scope.zyh = true;
				$scope.status.hasgot = true;
				reduceSec();
			} else { // 失败
				$scope.data.userAuthentication = true;
			}
		});
	}


}]);
